import React from "react";
import { connect } from "react-redux";
import SalaryAdditionTable from "./components/SalaryAdditionTable";
import UploadButton from "components/button/upload";
import DownloadButton from "components/button/download";

const SalaryAdditions = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<SalaryAdditionTable/>
	      	
	      	<div className="flex flex-row-reverse text-right">
	      		<DownloadButton downloadPath="salary-additions" title="Download" filters={filters}/>
	      		<UploadButton uploadPath='salary-additions' title="Upload"/>
	      	</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.salaryAddition.salaryAdditionList?.filters,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdditions);